import React from 'react';
// Constants
import {
  CompanyName,
  CompanyTagLine,
  KeywordsPages,
} from '../../utils/Constants';
// Data
import {
  fansitesPageAdditionalMeta,
  fansitesPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import FansitesPageMainContainer from '../../components/fansites/FansitesPageMainContainer';

function FansitesPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Fansites'
        desc={`Unlock exclusive content from ${CompanyName}. Explore My content, premium fansites, and indulge in experiences crafted just for you.`}
        keywords={KeywordsPages}
        additionalMeta={fansitesPageAdditionalMeta}
        structuredData={fansitesPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen w-full overflow-hidden font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        {/* Main */}
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />
          <header className='pt-24 px-8'>
            <h1 className='text-center font-titleFont text-5xl lg:text-6xl tracking-widest text-colour7'>
              Fansites
            </h1>
            <div className='mx-auto text-xl grid mt-2 justify-center px-4 text-center'>
              <h2>Fantasize with Liyah</h2>
            </div>
            <div>
              <p className='text-center text-lg mt-4 max-w-2xl mx-auto'>
                Step deeper into My world by joining My fansites—where the real
                fun begins. From exclusive photos and videos to intimate
                sessions and direct messaging, each platform offers something
                deliciously different. Subscribing is your first act of
                devotion.
              </p>
            </div>
          </header>

          {/* Main page content */}
          <FansitesPageMainContainer />
        </div>
      </div>
    </>
  );
}

export default FansitesPage;
